import {createContext} from 'react';

export const StaticData = createContext();
